import React from 'react';
import { FeatureRecord } from '../../../../../types/dato';
import { classNames, Image } from '@payfit/growth-platform-brand-system-v2';
import { Icon } from '@payfit/growth-platform-brand-system-v2/components/Picto/Icon';
import { Popover } from '@payfit/growth-platform-brand-system-v2/components/Popover';
import { decorationUnderlineDotted } from '@payfit/growth-platform-brand-system-v2/styles/typographyNew';
import { PricingPopoverContent } from '../PricingPopoverContent';

const FeatureLabel = ({ feature }: { feature: FeatureRecord }) => {
  if (feature.image) {
    return (
      <div className="flex items-center gap-[12px]">
        {feature.name}
        {feature.image && (
          <Image
            src={feature.image.url}
            alt={feature.image.alt}
            width={feature.image.width}
            height={feature.image.height}
            pixelDensity={'image_with_text'}
            sizes={'154px'}
            className={classNames('h-[28px] w-auto')}
          />
        )}
      </div>
    );
  }
  return feature.name;
};

const FeatureItem = ({
  feature,
  tooltipTitle,
  tooltipImage,
  tooltipText,
  hasTooltip,
}: {
  feature: FeatureRecord;
  className?: string;
  tooltipTitle?: string | null;
  tooltipImage?: any;
  tooltipText?: string | null;
  hasTooltip?: boolean;
}) => {
  return (
    <>
      {hasTooltip && (
        <Popover
          label={
            <div className={classNames(decorationUnderlineDotted)}>
              <FeatureLabel feature={feature} />
            </div>
          }
          position={'top'}
          className="w-fit"
        >
          <PricingPopoverContent
            image={tooltipImage}
            title={tooltipTitle}
            text={tooltipText}
            className="md:w-[280px]"
          />
        </Popover>
      )}
      {!hasTooltip && <FeatureLabel feature={feature} />}
    </>
  );
};

export default function Feature({ feature }: { feature: FeatureRecord }) {
  const tooltip = feature.tooltip;
  const tooltipTitle = tooltip?.title;
  const tooltipText = tooltip?.text;
  const tooltipImage = tooltip?.image;
  const hasTooltip = !!(tooltipTitle || tooltipText || tooltipImage) && true;

  return (
    <dd
      className={classNames(
        'flex items-start transition-transform',
        hasTooltip && 'hover:translate-x-[4px]',
      )}
    >
      <div
        className={classNames(
          'relative -left-[6px] -top-[2px] rounded-[6px] px-[6px] py-[6px]',
          'mr-[6px]',
        )}
      >
        <Icon
          name={'check'}
          width={12}
          height={12}
          twTextColor="text-[#ABBBCC]"
          className={classNames('h-[20px] w-[20px]')}
        />
      </div>
      <FeatureItem
        feature={feature}
        tooltipTitle={tooltipTitle}
        tooltipText={tooltipText}
        tooltipImage={tooltipImage}
        hasTooltip={hasTooltip}
      />
    </dd>
  );
}
